import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="textarea"
export default class extends Controller {
    connect() {
        this.onInput = this.onInput.bind(this)

        this.element.addEventListener("input", this.onInput)
        this.onInput()
    }

    disconnect() {
        this.element.removeEventListener("input", this.onInput)
    }

    onInput() {
        this.element.style.height = "auto"
        this.element.style.height = this.element.scrollHeight + "px"
    }
}
